<template>
  <div class="wrapper">
    <form class="contact-form" ref="form" @submit.prevent="save">
      <div class="rad md-layout">
        <div class="md-layout-item md-size-50">
          <label>Type de réponse*</label>

          <br />
          <br />
          <md-radio v-model="isValid" :value="true">
            Dossier accepté
          </md-radio>

          <br />
          <md-radio v-model="isValid" :value="false">
            Dossier refusé
          </md-radio>

          <div class="rad md-layout">
            <div class="md-layout-item md-size-50">
              <div style="margin-top: 50px">
                <label>Autres procédures possibles*</label>

                <br />
                <br />
                <md-checkbox v-model="autre" value="étude en France">
                  étude en France
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="étude au Usa">
                  étude aux Usa
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="étude en Turquie">
                  étude en Turquie
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="étude au Canada">
                  étude au Canada
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="étude en Albanie">
                  étude en Albanie
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="étude en Chine">
                  étude en Chine
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="étude au Japon">
                  étude au Japon
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="étude au CHYPRE DU NORD">
                  étude au CHYPRE DU NORD
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="étude au BRESIL">
                  étude au BRESIL
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="travail au Canada">
                  travail au Canada
                </md-checkbox>
              </div>
            </div>

            <div class="md-layout-item md-size-50">
              <div style="margin-top: 50px">
                <br />
                <br />
                <md-checkbox v-model="autre" value="tourisme en France">
                  tourisme en France
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="tourisme au Usa">
                  tourisme aux Usa
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="tourisme en Turquie">
                  tourisme en Turquie
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="tourisme au Canada">
                  tourisme au Canada
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="tourisme en Albanie">
                  tourisme en Albanie
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="tourisme en Chine">
                  tourisme en Chine
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="tourisme au Japon">
                  tourisme au Japon
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="tourisme en CHYPRE DU NORD">
                  tourisme en CHYPRE DU NORD
                </md-checkbox>

                <br />
                <md-checkbox v-model="autre" value="tourisme au BRESIL">
                  tourisme au BRESIL
                </md-checkbox>

              </div>
            </div>
          </div>
        </div>

        <div class="md-layout-item md-size-50">
          <label>Pièces à fournir*</label>

          <br />
          <br />
          <md-checkbox v-model="piece" value="Bulletins de Seconde et Première"
            >Bulletins de Seconde et Première</md-checkbox
          >

          <br />
          <md-checkbox v-model="piece" value="Bulletins de Terminale">
            Bulletins de Terminale
          </md-checkbox>

          <br />
          <md-checkbox v-model="piece" value="Relevé de BAC et diplôme"
            >Relevé de BAC et diplôme</md-checkbox
          >

          <br />
          <md-checkbox v-model="piece" value="Relevé BTS et Diplôme BTS"
            >Relevé BTS et Diplôme BTS</md-checkbox
          >

          <br />
          <md-checkbox v-model="piece" value="Relevé et Diplôme Licence"
            >Relevé et Diplôme Licence</md-checkbox
          >

          <br />
          <md-checkbox
            v-model="piece"
            value="Justificatif de toutes les années après le BAC"
            >Justificatif de toutes les années après le BAC</md-checkbox
          >

          <br />
          <md-checkbox
            v-model="piece"
            value="Attestation de Stage/ Formation/ Travail"
            >Attestation de Stage/ Formation/ Travail</md-checkbox
          >

          <br />
          <md-checkbox v-model="piece" value="Passeport">Passeport</md-checkbox>

          <br />
          <md-checkbox v-model="piece" value="Acte de naissance"
            >Acte de naissance</md-checkbox
          >

          <br />
          <md-checkbox v-model="piece" value="Photo d’identité"
            >Photo d’identité</md-checkbox
          >

          <br />
          <md-checkbox
            v-model="piece"
            value="Relevé et Diplôme du BAC traduite en anglais"
            >Relevé et Diplôme du BAC traduite en anglais</md-checkbox
          >
        </div>
      </div>

      {{ sender }}

      <div style="text-align: center">
        <pulse-loader
          :loading="loading"
          color="black"
          size="20px"
        ></pulse-loader>
      </div>
    </form>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  bodyClass: "landing-page",

  components: {
    PulseLoader
  },

  data() {
    return {
      isValid: true,
      loading: false,
      piece: [],
      autre: []
    };
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    sender() {
      if (this.piece.length > 0) {
        console.log(this.piece);
        let obj = {
          isValid: this.isValid,
          piece: this.piece,
          autre: this.autre
        };

        this.$emit("info", obj);
      }
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.md-success {
  margin-top: 3rem;
}
.hooper {
  height: auto;
}
.rad {
  margin-top: 30px;
}
.alert-success,
.alert-danger {
  margin-top: 50px;
}
</style>
